<template>
    <div>
      <Head title="Order Pick-up Issuances" />
      <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" :href="`/pick-up-queue/${order.id}/show`">Pick-up Queue</Link>
      <span class="text-orange-400 font-medium">/</span>{{ order.order_no }}/Issuances
    </h1>
      <div class="flex items-center justify-between mb-6">
      </div>
      <div class="bg-white rounded-md shadow overflow-x-auto">
        <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <div class="bg-white rounded-md shadow mb-5">
                <form @submit.prevent="store">
                  <div class="flex flex-wrap -mb-2 -mr-6 pt-8 pl-8 pr-8 pb-8">
                    <div class="w-full lg:w-full">
                      <text-input
                        v-model="form.item_id"
                        :error="form.errors.item_id"
                        class="pb-2 pr-6 w-full lg:w-full"
                        placeholder="Scan UID"
                      />
                    </div>
                  </div>
                  <div
                    class="flex items-center justify-end w-full px-8 py-4 bg-gray-50 border-t border-gray-100"
                    >
                    <loading-button
                        :loading="form.processing"
                        class="btn-orange px-3 py-2 text-xs"
                        type="submit"
                    >
                        Issue
                    </loading-button>
                    </div>
                </form>
              </div>
              <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
                <table class="w-full whitespace-nowrap">
                  <tr class="text-left font-bold">
                    <th class="pb-3 pt-3 px-3">Date</th>
                    <th class="pb-3 pt-3 px-3">Item UID</th>
                    <th class="pb-3 pt-3 px-3">Part Number</th>
                    <th class="pb-3 pt-3 px-3">Description</th>
                    <th class="pb-3 pt-3 px-3">Quantity</th>
                    <th class="pb-3 pt-3 px-3">UoM</th>
                    <th class="pb-3 pt-3 px-3">Issued By</th>
                  </tr>
                  <tr v-for="item in issuances" :key="item.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
                    <td class="border-t">
                      <span class="flex items-center px-3 py-2 focus:text-orange-500">
                        {{ item.date }}
                      </span>
                    </td>
                    <td class="border-t">
                      <span class="flex items-center px-3 py-2" tabindex="-1">
                        {{ item.uid }}
                      </span>
                    </td>
                    <td class="border-t">
                      <span class="flex items-center px-3 py-2" tabindex="-1">
                        {{ item.part_umber }}
                      </span>
                    </td>
                    <td class="border-t">
                      <span class="flex items-center px-3 py-2" tabindex="-1">
                        {{ item.description }}
                      </span>
                    </td>
                    <td class="border-t">
                      <span class="flex items-center px-3 py-2 text-center" tabindex="-1">
                        {{ item.quantity }}
                      </span>
                    </td>
                    <td class="border-t">
                      <span class="flex items-center px-3 py-2 text-center" tabindex="-1">
                        {{ item.measure }}
                      </span>
                    </td>
                    <td class="border-t">
                      <span class="flex items-center px-3 py-2" tabindex="-1">
                        {{ item.issued_by }}
                      </span>
                    </td>
                  </tr>
                  <tr v-if="issuances.length === 0">
                    <td class="px-6 py-4 border-t" colspan="8">No data found</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
    </div>   
  </template>
    
  <script>
  import { Head, Link } from '@inertiajs/inertia-vue3'
  import Icon from '@/Shared/Icon'
  import Layout from '@/Shared/Layout'
  import Pagination from '@/Shared/Pagination'
  import TextInput from '@/Shared/TextInput'
  import LoadingButton from '@/Shared/LoadingButton'
    
  export default {
    components: {
      Head,
      Icon,
      Pagination,
      TextInput,
      Link,
      LoadingButton,
    },
    layout: Layout,
    props: {
      order: Object,
      issuances: Object,
      sku: Object,
    },
    data() {
      return {
        form: this.$inertia.form({
          item_id: null,
          quantity: null
        }),
      }
    },
    methods: {
      store() {
        this.form.post(`/orders/${this.order.id}/skus/${this.sku.id}/pick-up/issuance`, {
          onSuccess: () => {
            this.form.reset(
              'quantity',
              'item_id'
            )
          }
        })
      },
    },
  }
  </script>
    